import styled from 'styled-components'

import ProfileEditFormUnstyled from 'Containers/Form/Profile/ProfileEdit/unstyled'

export const ProfileEditForm = styled(ProfileEditFormUnstyled)``



// WEBPACK FOOTER //
// ./src/Containers/Form/Profile/ProfileEdit/index.js